import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { ExternalUserFlatListQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-flat-list-query.dto';
import type { ExternalUserInviteOneQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-invite-one-query.dto';
import type { ExternalUserRegistryQueryInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-registry-query.dto';
import type { ExternalUserRegistryPageInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-registry-page.dto';
import type { RoomAccessFindInterface } from '@zaoblako/shared/modules/security/dtos/room-access/room-access-find.dto';
import type { RoomAccessFormInterface } from '@zaoblako/shared/modules/security/dtos/room-access/room-access-form.dto';

import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalUserService extends BaseService {
  protected baseUrl = '/basis/security/external-user';

  public findManyFlat(params?: ExternalUserFlatListQueryInterface): Observable<ExternalUserFindInterface[]> {
    return this.http.get<ExternalUserFindInterface[]>(`${this.baseUrl}/flat`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor(): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);
  }

  public findRegistryItems(params?: ExternalUserRegistryQueryInterface): Observable<ExternalUserRegistryPageInterface> {
    return this.http.get<ExternalUserRegistryPageInterface>(`${this.baseUrl}/items`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public inviteOne(id: number, params?: ExternalUserInviteOneQueryInterface): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${id}/invite`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public ban(id: number): Observable<ExternalUserFindInterface> {
    return this.http.post<ExternalUserFindInterface>(`${this.baseUrl}/${id}/ban`, null);
  }

  public unban(id: number): Observable<ExternalUserFindInterface> {
    return this.http.post<ExternalUserFindInterface>(`${this.baseUrl}/${id}/unban`, null);
  }

  public getPacsAccess(id: number): Observable<RoomAccessFindInterface> {
    return this.http.get<RoomAccessFindInterface>(`${this.baseUrl}/${id}/pacs-access`);
  }

  public setPacsAccess(id: number, body: RoomAccessFormInterface): Observable<RoomAccessFindInterface> {
    return this.http.put<RoomAccessFindInterface>(`${this.baseUrl}/${id}/pacs-access`, body);
  }

  public blockAllAccessCards(params?: ExternalUserFlatListQueryInterface): Observable<null> {
    return this.http.post<null>(`${this.baseUrl}/block-all-access-cards`, {}, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }
}
